export const primaryColor = "#00b5e2";
export const secondaryColor = "#f98228";
